import { SuSyApi } from '../../api/susyApi';
import { Dispatch } from 'react';
import { PostDispatch } from '../types';
import { transformDateFormat } from 'susy-common/date-utils';
import { ProjectActionType } from '../actionTypes/project';

export const createSubmission =
    (projectId: string) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.post(
            `/plagiarismChecker/submission/create/${projectId}`
        );

        dispatch({
            type: ProjectActionType.CREATE_PLAGIARISM_CHECK_SUBMISSION,
            payload: transformDateFormat(response.data),
        });
    };

